import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Slideshow from './components/Slideshow';
import Clients from './components/Clients';
import Footer from './components/Footer';
import Team from './pages/Team';
import About from './pages/About';
import Support from './pages/Support'
import Industry from './pages/Industry'
import Future from './pages/Future'
import Quality from './pages/Quality'
import Confidentiality from './pages/Confidentiality'
import Indemnity from './pages/Indemnity'
import Contact from './pages/Contact'
import './App.css';
import ScrollToTop from './components/ScrollToTop';
import ChatWidget from './components/ChatWidget';

const App = () => {
  return (
    <Router>
    <ScrollToTop />
      <Navbar />
      <ChatWidget />
      <Routes>
        <Route path="/" element={
          <>
            <Hero />
            <Slideshow />
            <Services />
            <Clients />
            <Footer />
          </>
        } />
        <Route path="/team" element={<Team />} />
        <Route path="/about" element={<About />} />
        <Route path="/support" element={<Support />} />
        <Route path="/industry" element={<Industry />} />
        <Route path="/future" element={<Future />} />
        <Route path="/quality" element={<Quality />} />
        <Route path="/confidentiality" element={<Confidentiality />} />
        <Route path="/indemnity" element={<Indemnity />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Router>
  );
};

export default App;